@if (componentIsVisible) {
<ng-container
    *ngrxLet="{
            componentType: componentType$,
            actionButtonType: actionButtonType$,
        } as vm">
    @if (allowDrag()) {
    <floori-action-container-header
        flooriDragContainerHandle
        [class.border-radius]="isDialog()"
        [showCloseButton]="showCloseButton()"
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        [tertiaryButton]="tertiaryButton()"
        [showSelector]="showSelector()"
        [selectorValue]="selectorValue()"
        [title]="headerLabel"
        [icon]="headerIcon"
        [message]="headerMessage"
        [headerType]="headerType()"
        (closeClick)="closePanel()"
        (primaryButtonClick)="primaryButtonClickHandler()"
        (secondaryButtonClick)="secondaryButtonClickHandler()"
        (tertiaryButtonClick)="tertiaryButtonClickHandler()"
        (selectorClick)="selectorClickHandler()">
        <ng-container
            *ngComponentOutlet="vm.actionButtonType; injector: buttonInjector"></ng-container>
    </floori-action-container-header>
    } @else {
    <floori-action-container-header
        [class.border-radius]="isDialog()"
        [showCloseButton]="showCloseButton()"
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        [tertiaryButton]="tertiaryButton()"
        [showSelector]="showSelector()"
        [selectorValue]="selectorValue()"
        [title]="headerLabel"
        [icon]="headerIcon"
        [message]="headerMessage"
        [headerType]="headerType()"
        (closeClick)="closePanel()"
        (primaryButtonClick)="primaryButtonClickHandler()"
        (secondaryButtonClick)="secondaryButtonClickHandler()"
        (tertiaryButtonClick)="tertiaryButtonClickHandler()"
        (selectorClick)="selectorClickHandler()">
        <ng-container
            *ngComponentOutlet="vm.actionButtonType; injector: buttonInjector"></ng-container>
    </floori-action-container-header>
    }
    <ng-content></ng-content>
    <div class="action-container-view">
        <div class="action-container-view-inner">
            <ng-container
                *ngComponentOutlet="vm.componentType; injector: componentInjector"></ng-container>
        </div>
    </div>
</ng-container>
}
